import { Component, OnInit } from '@angular/core';
import { ValidatorFn, FormBuilder, FormGroup, Validator } from '@angular/forms';
import { FILE } from 'dns';
import { BsModalRef, BsModalService } from "ngx-bootstrap/modal";
import { Subject } from 'rxjs';
import { take } from 'rxjs/operators';
import { DiscussionService } from 'src/app/shared-service/services/discussion.service';
import { BasePopupComponent } from '../base-popup/base-popup.component';

@Component({
  selector: 'app-create-story-modal',
  templateUrl: './create-story-modal.component.html',
  styleUrls: ['./create-story-modal.component.css']
})



export class CreateStoryModalComponent implements OnInit {

  storyForm: FormGroup;
  user_id:'';
  storyError: boolean = false;
  selectedIndex: number = 0;
  fileToUpload: File = null;
  filePath: string;
  storyTitle: string;
  storyTitleColor: string = '';
  colorCollections = [
    {
      color_name: "black",
      color_code: "#000000"
    },
    {
      color_name: "grey",
      color_code: "#545454"
    },
    {
      color_name: "light-grey",
      color_code: "#737373"
    },
    {
      color_name: "silver",
      color_code: "#A6A6A6"
    },
    {
      color_name: "light-silver",
      color_code: "#D9D9D9"
    },
    {
      color_name: "white",
      color_code: "#FFFFFF"
    },
    {
      color_name: "red",
      color_code: "#FF1616"
    },
    {
      color_name: "light-red",
      color_code: "#FF5757"
    },
    {
      color_name: "pink",
      color_code: "#FF66C4"
    },
    {
      color_name: "indigo",
      color_code: "#CB6CE6"
    },
    {
      color_name: "voilet",
      color_code: "#8C52FF"
    },
    {
      color_name: "navy-blue",
      color_code: "#5E17EB"
    },
    {
      color_name: "green-shade",
      color_code: "#03989E"
    },
    {
      color_name: "green-shade-2",
      color_code: "#00C2CB"
    },
    {
      color_name: "green-shade-3",
      color_code: "#5CE1E6"
    },
    {
      color_name: "blue",
      color_code: "#38B6FF"
    },
    {
      color_name: "dark-blue",
      color_code: "#5271FF"
    },
    {
      color_name: "deepblue",
      color_code: "#004AAD"
    },
    {
      color_name: "dark-green",
      color_code: "#008037"
    },
    {
      color_name: "light-green",
      color_code: "#7ED957"
    },
    {
      color_name: "grass-green",
      color_code: "#C9E265"
    },
    {
      color_name: "yellow",
      color_code: "#FFDE59"
    },
    {
      color_name: "orange",
      color_code: "#FFBD59"
    },
    {
      color_name: "darkorange",
      color_code: "#FF914D"
    }

  ];
  userData:any;
  userId='';
  profileUrl ='';
  customProfileName='';
  colorPallete = ['green','pink','orange','red','blue', 'gold', 'yelow','violet','silver'];
  colorPick = '';
  isSubmit=false;
  showSupportText=false;

  public onHide: Subject<any> = new Subject<any>();
  constructor(
    public bsModalRef: BsModalRef,
    private discussionService: DiscussionService,
    private modalService: BsModalService,
    public fb: FormBuilder
  ) {
    this.storyForm = this.fb.group({
      img: [null],
      filename: [''],
      fileUpload:[''],
      storyDescription: ['']
    },
    {
      validator: customValidation('fileUpload','storyDescription')
    })
   }

  ngOnInit() {
    this.colorCollections;
    document.getElementById('story-files').click();
    if (localStorage.getItem('userData')) {
      this.userData = JSON.parse(localStorage.getItem('userData'));
      this.userId = this.userData.user_id;
      if(this.userData.profile_pic && this.userData.profile_pic.indexOf('dummy-profile') == -1) {
        this.profileUrl = this.userData.profile_pic;
      } else {
        this.customProfileName = this.userData.first_name.charAt(0).toUpperCase() + this.userData.last_name.charAt(0).toUpperCase();
      //  this.customProfileName = 'UK';
        this.colorPick = this.colorPallete[Math.floor(Math.random() * 9)]
      }
    }

  }

  colorSelction(colorCode){
    this.storyTitleColor = colorCode;
  }

  open(content) {
    if(content =='section2'){
      this.storyTitle = (<HTMLInputElement>document.getElementById("storyDescription")).value;
      this.storyTitleColor = this.storyTitleColor;
      document.getElementById('preview-story-modal-header').parentElement.style.display = "block";
      document.getElementById('preview-story-modal-header').style.display = "block";
      document.getElementById('preview-story-modal-body').style.display = "block";

      document.getElementById('create-story-modal-header').parentElement.style.display = "none";
      document.getElementById('create-story-modal-header').style.display = "none";
      document.getElementById('create-story-modal-body').style.display = "none";
    }else if(content == 'section1'){
      document.getElementById('preview-story-modal-header').parentElement.style.display = "none";
      document.getElementById('preview-story-modal-header').style.display = "none";
      document.getElementById('preview-story-modal-body').style.display = "none";

      document.getElementById('create-story-modal-header').parentElement.style.display = "block";
      document.getElementById('create-story-modal-header').style.display = "block";
      document.getElementById('create-story-modal-body').style.display = "block";
    }
  }

  imagePreview(e) {
    const file = (e.target as HTMLInputElement).files[0];
  //  this.fileToUpload = (e.target as HTMLInputElement).files[0];

    const allowed_types = ['image/png','image/jpg','image/jpeg'];
    let fileType =  file.type;
    if(allowed_types.includes(fileType)) {
      this.fileToUpload = (e.target as HTMLInputElement).files[0];
      this.showSupportText = false;
      this.storyForm.patchValue({
        img: file
      });

      this.storyForm.get('img').updateValueAndValidity()

      const reader = new FileReader();
      reader.onload = () => {
        this.filePath = reader.result as string;
      }
      reader.readAsDataURL(file)
    } else {
      this.showSupportText = true;
    }
  }

  removeFile() {
    this.filePath = '';
  }

  setIndex(index: number) {
    this.selectedIndex = index;
 }

  closeModal(result){
    this.onHide.next(result);
    this.bsModalRef.hide();
  }

  processImageSize() {
    // var canvas = document.getElementById("canvas");
    // var ctx = canvas.getContext("2d");
    // var img = new Image();

    // img.onload = function () {

    //     // set size proportional to image
    //     canvas.height = canvas.width * (img.height / img.width);

    //     // step 1 - resize to 50%
    //     var oc = document.createElement('canvas'),
    //         octx = oc.getContext('2d');

    //     oc.width = img.width * 0.5;
    //     oc.height = img.height * 0.5;
    //     octx.drawImage(img, 0, 0, oc.width, oc.height);

    //     // step 2
    //     octx.drawImage(oc, 0, 0, oc.width * 0.5, oc.height * 0.5);

    //     // step 3, resize to final size
    //     ctx.drawImage(oc, 0, 0, oc.width * 0.5, oc.height * 0.5,
    //     0, 0, canvas.width, canvas.height);
    // }
    // img.src = "//i.imgur.com/SHo6Fub.jpg";
  }

  submitStory(){
    this.isSubmit=true;
    this.storyTitle = (<HTMLInputElement>document.getElementById("storyDescription")).value;

    const formData = new FormData();
    formData.append('user_id', this.userId);
    formData.append('story_description', this.storyTitle);
    formData.append('story_file', this.fileToUpload);
    formData.append('story_title_color', this.storyTitleColor);
    this.discussionService.addStories(formData).subscribe((result:any) => {
      if(result && result.state == 200) {
        this.discussionService.newStoriesRefresh.next(true);
        this.closeModal(result);
      } else {
        this.isSubmit=false;
        const initialState = {title:'Invalid Image', description: result.msg};
        this.modalService.show(BasePopupComponent, {initialState}).content.onHide
        .pipe(take(1))
        .subscribe((result: boolean) => {
            //this.router.navigate(['/user/discuss']);
        });
        this.discussionService.newStoriesRefresh.next(false);
      }
    })
  }

}

function customValidation(fileUpload: string, storyDescription: string){
  return(formGroup: FormGroup)=>{
    const fileUpload = formGroup.controls['fileUpload'];
    const storyDescription = formGroup.controls['storyDescription'];
    if (fileUpload.value =='' && storyDescription.value == ''){
      storyDescription.setErrors({customValidator: true})
    }else{
      storyDescription.setErrors(null)
    }
  }
}
